class CartRemoveButton extends HTMLElement {
    constructor() {
      super();
  
      this.addEventListener('click', (event) => {
        event.preventDefault();
        const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
        cartItems.updateQuantity(this.dataset.index, 0);
      });
    }
  }
  
  customElements.define('cart-remove-button', CartRemoveButton);
  
  class CartItems extends HTMLElement {
    constructor() {
      super();
      this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');
  
      const debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, ON_CHANGE_DEBOUNCE_TIMER);
  
      this.addEventListener('change', debouncedOnChange.bind(this));
      window.addEventListener("load", this.onCartUpdate);
    }
  
    cartUpdateUnsubscriber = undefined;
  
    connectedCallback() {
      
      this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event.source === 'cart-items') {
          return;
        }
        this.onCartUpdate();
      });
    }
  
    disconnectedCallback() {
      if (this.cartUpdateUnsubscriber) {
        this.cartUpdateUnsubscriber();
      }
    }
  
    onChange(event) {
      if(event.target.value > 10 && document.activeElement.getAttribute('name') == 'plus'){
        document.activeElement.setAttribute('disable', 'true');
        event.target.value = 10;
      }
      if(event.target.value <= 10){
        this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
      }

    }
  
    onCartUpdate() {
      $.getJSON('/cart.js', function(cart){

        $('#CartDrawer-Checkout').removeClass('btn-loading');
        $('#CartDrawer-Checkout').attr("disabled", false);
        
        if(cart.item_count > 0){
          document.querySelector('.drawer ').classList.remove('is-empty');
        }

        

        fetchUpdatedCart(cart)
      });

      function fetchUpdatedCart(cart) {
        const body = JSON.stringify({
          items : cart.items,
          sections: 'cart-drawer',
          sections_url: window.location.pathname
        })
        
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body }})
        .then((response) => response.text())
        .then((responseText) => {
          console.log(JSON.parse(responseText))
          const parsedResponse = JSON.parse(responseText)
          const html = new DOMParser().parseFromString(parsedResponse.sections["cart-drawer"], 'text/html');
          const sourceQty = html.querySelector('.drawer__inner');
          const sectionElement =  document.querySelector('.drawer__inner');
          sectionElement.innerHTML = sourceQty.innerHTML;

          if(Number($('.totals__subtotal-value').text().replace('$','')) > 70){
            document.querySelector('.shipping').classList.add('show-shipping');
          }
          else{
            document.querySelector('.shipping').classList.remove('show-shipping');
          }

          $('#CartDrawer-Checkout').on("click", function(e) {
            $(this).addClass('btn-loading');
            $(this).attr("disabled", true);
    
            cart_scripts.init();
          })
        })
        .catch(e => {
          console.error(e);
        });
      }
      
    }

    
    getSectionsToRender() {
      return [
        {
          id: 'main-cart-items',
          section: document.getElementById('main-cart-items').dataset.id,
          selector: '.js-contents'
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section'
        },
        {
          id: 'cart-live-region-text',
          section: 'cart-live-region-text',
          selector: '.shopify-section'
        },
        {
          id: 'main-cart-footer',
          section: document.getElementById('main-cart-footer').dataset.id,
          selector: '.js-contents'
        }
      ];
    }
  
    updateQuantity(line, quantity, name) {
      // this.enableLoading(line);
  
      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });
  
      fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);
          const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
          const items = document.querySelectorAll('.cart-item');
  
          if (parsedState.errors) {
            quantityElement.value = quantityElement.getAttribute('value');
            this.updateLiveRegions(line, parsedState.errors);
            return;
          }
  
          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartDrawerWrapper = document.querySelector('cart-drawer');
          const cartFooter = document.getElementById('main-cart-footer');
  
          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
  
          this.getSectionsToRender().forEach((section => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            elementToReplace.innerHTML =
              this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          }));
          const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
          let message = '';
          if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
            if (typeof updatedValue === 'undefined') {
              message = window.cartStrings.error;
            } else {
              message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
            }
          }
          this.updateLiveRegions(line, message);
  
          const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
            cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
            
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
          } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
          }
          
          // this.cartTotalWithSubscription(parsedState);
          publish(PUB_SUB_EVENTS.cartUpdate, {source: 'cart-items'});

          setTimeout(function(){
            $.getJSON('/cart.js', function(cart){ 
              var result = cart.item_count;
              console.log(cart)
              $('.js-cart-trigger #CartCount').text(result);
            });
          },300);

          if(Number($('.totals__subtotal-value').text().replace('$','')) > 70){
            document.querySelector('.shipping').classList.add('show-shipping');
          }
          else{
            document.querySelector('.shipping').classList.remove('show-shipping');
          }
          
          $('#CartDrawer-Checkout').on("click", function(e) {
              $(this).addClass('btn-loading');
              $(this).attr("disabled", true);
      
              cart_scripts.init();
            })
          
        }).catch(() => {
          this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
          const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
          errors.textContent = window.cartStrings.error;
        })
        .finally(() => {
          this.disableLoading(line);
        });
    }


    cartTotalWithSubscription(cart) {
      $cartCostSelector = $('.totals__subtotal-value');
      var itemTotal = 0;
      for (var i = 0; i < cart.items.length; i++) {
        var discountedValue = 0;

        if (Object.keys(cart.items[i].properties).length !== 0) {
          var itemWithSubscription = cart.items[i].properties.payload;
          itemWithSubscription.subscription.discounts.forEach(function (discountItem) {
            if (discountItem.name == 'product_lines') {
              if(discountItem.discount_type === "percentage") {
                discountedValue = discountedValue + (cart.items[i].final_price * discountItem.discount_value) / 100;
              } else {
                discountedValue = discountedValue + (discountItem.discount_value);
              }
            }
          });

          itemTotal = itemTotal + (cart.items[i].final_price - discountedValue) * cart.items[i].quantity;
        } else {
          itemTotal = itemTotal + cart.items[i].final_price * cart.items[i].quantity;
        }
      }

      var cartTotalWithDiscount = Shopify.formatMoney(itemTotal, '${{ amount }}');
      $cartCostSelector.html(cartTotalWithDiscount);
      
      // this.calculateTotalSavings(cartModel, itemTotal);
    }

    calculateTotalSavings(cart_model, itemTotal) {
      $saving_total = $('.saving_total');
      let total_item_discount = 0;
  
      for (const i in cart_model.items) {
        let item = cart_model.items[i];
        if(item.compare_at_price !== null && item.compare_at_price !== undefined){
  
          total_item_discount =
          total_item_discount +
          (item.compare_at_price * item.quantity);
        }
        else if( item.price !== null && item.price !== undefined){

          total_item_discount =
          total_item_discount +
          ((item.price * item.quantity));
        }
  
      }
  
      var saving_value =  total_item_discount - itemTotal;
      var saving_total = Shopify.formatMoney(saving_value, '${{ amount }}');
      $saving_total.html(saving_total)
    }
  
    updateLiveRegions(line, message) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;
  
      this.lineItemStatusElement.setAttribute('aria-hidden', true);
  
      const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
      cartStatus.setAttribute('aria-hidden', false);
  
      setTimeout(() => {
        cartStatus.setAttribute('aria-hidden', true);
      }, 1000);
    }
  
    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
  
    enableLoading(line) {
      const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
      mainCartItems.classList.add('cart__items--disabled');
  
      const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
      const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);
  
      [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));
  
      document.activeElement.blur();
      this.lineItemStatusElement.setAttribute('aria-hidden', false);
    }
  
    disableLoading(line) {
      const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
      mainCartItems.classList.remove('cart__items--disabled');
  
      const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
      const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);
  
      cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
      cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    }
  }
  
  customElements.define('cart-items', CartItems);
  
  if (!customElements.get('cart-note')) {
    customElements.define('cart-note', class CartNote extends HTMLElement {
        constructor() {
          super();
  
        this.addEventListener('change', debounce((event) => {
              const body = JSON.stringify({ note: event.target.value });
              fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, ON_CHANGE_DEBOUNCE_TIMER))
        }
    });
  };
  